import React from 'react';
import { useQuery } from 'react-query';
import {
  getAttachment,
  getAttachmentsByObjective
} from '../../../api/objective/attachments.api';
import { Divider, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import formatBytes from '../../../utils/formatBytes';
import CreateAttachment from './CreateAttachment';
import { useSelector } from 'react-redux';
import DeleteAttachment from './DeleteAttachment';
import ReactTimeAgo from 'react-time-ago';
import i18next from 'i18next';

const useStyles = makeStyles({
  attachmentRoot: {
    background: '#F4F4F4',
    padding: 16
  },
  title: {
    color: '#999',
    fontSize: 12,
    marginBottom: 8,
    textTransform: 'uppercase'
  },
  attachmentItem: {
    marginBottom: 8
  },
  attachmentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    margin: '8px 0'
  },
  uploader: {
    color: 'black',
    fontWeight: 'bold'
  },
  uploadTime: {
    color: '#999999',
    fontSize: 12,
    marginLeft: 'auto'
  },
  fileName: {
    wordBreak: 'break-word'
  },
  fileSize: {
    fontSize: 12,
    marginLeft: 'auto',
    whiteSpace: 'nowrap'
  }
}, { name: 'ObjectiveAttachments' });

const Attachments = ({
  objective
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const lng = i18next.languages[0];

  const { accountInfo, employee } = useSelector(state => state);

  const employees = [
    ...accountInfo.possibleAppraisers,
    employee
  ];

  const ownerId = objective.owner[0].id;
  const ownerType = objective.owner[0].type;
  const objectiveId = objective.id;

  const query = useQuery(
    [ 'objectiveAttachment', objectiveId ],
    async () => {
      const { data } = await getAttachmentsByObjective({
        objectiveId,
        ownerId,
        ownerType
      });
      return data;
    }
  );

  async function downloadAttachment ({ attachmentId, fileName }) {
    const { data } = await getAttachment({ objectiveId, attachmentId });
    const url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
  }

  return (
    <div className={ classes.attachmentRoot }>
      <Typography className={ classes.title }>{t('objective.attachment.title.list')}</Typography>
      {query.data?.map(attachment =>  (
        <div key={ attachment.objectiveAttachmentId } className={ classes.attachmentItem }>
          <div className={ classes.attachmentRow }>
            <span className={ classes.uploader }>
              {employees.find(emp => emp.empid === attachment.createdBy)?.name}
            </span>
            <ReactTimeAgo
              className={ classes.uploadTime }
              date={ new Date(attachment.createdAt) }
              locale={ lng }
            />
          </div>
          <div className={ classes.attachmentRow }>
            <a
              href={ `/attachment/${attachment.objectiveAttachmentId}` }
              onClick={ e => {
                e.preventDefault();
                downloadAttachment({
                  attachmentId: attachment.objectiveAttachmentId,
                  fileName: attachment.originalFileName
                });
              } }
              className={ classes.fileName }
            >
              {attachment.originalFileName}
            </a>
            <span className={ classes.fileSize }>{formatBytes(attachment.size)}</span>
          </div>
          {employee.empid === attachment.employeeId &&
            <DeleteAttachment
              name={ attachment.originalFileName }
              objectiveAttachmentId={ attachment.objectiveAttachmentId }
              objectiveId={ objectiveId }
              ownerId={ ownerId }
              ownerType={ ownerType }
              onSuccess={ query.refetch }
            />
          }
          <Divider />
        </div>
      ))}
      <CreateAttachment
        objectiveId={ objectiveId }
        ownerId={ ownerId }
        ownerType={ ownerType }
        onSuccess={ query.refetch }
      />
    </div>
  );
};

export default Attachments;